import defaultReducer from "./defaultReducer";

export const setActiveInstallationReducer = defaultReducer(
  "SET_ACTIVE_INSTALLATION",
  {},
);

export const installationReducer = defaultReducer("FETCH_INSTALLATIONS", {
  grid: { date: [], headerDef: [], rowDef: [] },
  isSuspended: false,
});

export const addPositionsReducer = defaultReducer("ADD_POSITIONS", "");
